<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">핏페이 매출</span>
            <span class="txt">핏페이 결제에 관한 결제현황과 매출을 확인합니다.</span>
        </div>

        <div class="com-tab">
            <span v-for="(item, index) in submenus" :key="index">
                <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                    {{ item.label }}
                </router-link>
            </span>
        </div>

        <div class="fit-filter-search mt-16">
            <div class="mb-4">
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="검색어를 입력해주세요"
                        class="mr-2"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="com-btn drop" :class="openFilter ? 'up' : 'down'" @click="openFilter = !openFilter">
                        필터 검색
                    </button>
                    <button class="com-search-reset" @click="resetSearchContent"></button>
                </div>
            </div>
            <table class="com-table" :class="openFilter ? '' : 'd-none'">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: auto" />
                    <col style="width: 120px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>처리 기간</th>
                        <td colspan="3">
                            <div class="d-flex align-items-center">
                                <div class="com-calendar-wrap">
                                    <single-calendar
                                        :start-date="startDate"
                                        @update="startDateUpdate"
                                    ></single-calendar>
                                    <div class="com-dash"><span class="dash">~</span></div>
                                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                </div>
                                <select-form
                                    :select-data="['선택', ...periodTypeList]"
                                    :select-value="['', ...periodTypeValueList]"
                                    :selected-value="searchPeriod"
                                    @update:set="(val) => (searchPeriod = val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>결제 상태</th>
                        <td colspan="3">
                            <div class="d-flex align-items-center">
                                <div v-for="(item, index) in payStates" :key="index" class="com-box-radio md">
                                    <input
                                        :id="'pay-state-' + index"
                                        v-model="payState"
                                        :value="item.value"
                                        name="pay-state"
                                        required
                                        type="radio"
                                    />
                                    <label :for="'pay-state-' + index">{{ item.text }}</label>
                                </div>
                            </div>
                        </td>
                        <!-- <th>진행 상태</th>
            <td>
              <div class="d-flex align-items-center">
                <select-form :select-data='payState === "C" ? ["전체", "취소진행중", "취소성공", "취소실패"] : ["전체", "결제완료", "취소진행중", "취소성공", "취소실패"]'
                            :select-value="payState === 'C' ? ['', 'C', 'R', 'F'] : ['', 'D', 'C', 'R', 'F']"
                            :disabled="payState === 'D'"
                            :selected-value='procState'
                            @update:set='val => procState = val'></select-form>
              </div>
            </td> -->
                    </tr>
                    <tr>
                        <th>이용권 구분</th>
                        <td colspan="3">
                            <div class="d-flex align-items-center">
                                <div v-for="(item, index) in ticketOptions" :key="index" class="com-box-radio md">
                                    <input
                                        :id="'ticket-type-' + index"
                                        v-model="searchTicketType"
                                        :value="item.value"
                                        name="ticket-type"
                                        required
                                        type="radio"
                                    />
                                    <label :for="'ticket-type-' + index">{{ item.text }}</label>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="sub-title">결제 현황</div>
        <!-- 매출현황 상품일시 -->
        <div class="sales-info-table w-auto mt-6">
            <div class="top-content">
                <div class="item-box flex-fill">
                    <span class="tit">결제 완료</span>
                    <span class="count">
                        <span class="num blue">{{ (totalPrices.bill_price || 0) | numberFormatFilter }}원</span>
                        <span class="txt">({{ (totalPrices.bill_count || 0) | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box minus"></div>
                <div class="item-box flex-fill">
                    <span class="tit">취소</span>
                    <span class="count">
                        <span class="num red">{{ (totalPrices.cancel_price || 0) | numberFormatFilter }}원</span>
                        <span class="txt">({{ (totalPrices.cancel_count || 0) | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box equal"></div>
                <div class="item-box flex-fill">
                    <span class="tit">총 합계</span>
                    <span class="count">
                        <span class="num green">
                            {{
                                ((totalPrices.bill_price || 0) - (totalPrices.cancel_price || 0)) | numberFormatFilter
                            }}원
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <!-- //매출현황 상품일시 -->

        <div class="sub-title mt-10">결제 내역</div>
        <div class="d-none align-items-center gap-4 mt-4">
            <button class="com-btn" @click="test1">핏페이 거래대사 조회(테스트용)</button>
            <button class="com-btn" @click="test2">핏페이 정산대사 조회(테스트용)</button>
            <button class="com-btn" @click="test3">핏페이 링크결제 내역 조회(테스트용)</button>
        </div>
        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 96px" />
                    <col style="width: 104px" />
                    <col style="width: 144px" />
                    <col style="width: 80px" />
                    <col style="width: auto" />
                    <col style="width: 110px" />
                    <col style="width: 120px" />
                    <col style="width: 160px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 140px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button :class="sortClassState('처리일')" @click="handleSortColumn('처리일')">
                                처리일
                            </button>
                        </th>
                        <th>결제 상태</th>
                        <th>
                            <button :class="sortClassState('주문번호')" @click="handleSortColumn('주문번호')">
                                주문번호
                            </button>
                        </th>
                        <th>구분</th>
                        <th>이용권 명</th>
                        <th>회원명</th>
                        <th>휴대전화번호</th>
                        <th>결제 수단</th>
                        <th>금액</th>
                        <th>
                            <button :class="sortClassState('최종금액')" @click="handleSortColumn('최종금액')">
                                최종금액
                            </button>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="s in fitpayList" :key="s.id">
                        <td>{{ s.nt_reg_dt | dateFormatFilter }}</td>
                        <td>
                            <span v-if="transState(s) === '결제대기'" class="pay-state-P">결제대기</span>
                            <span v-if="transState(s) === '취소'" class="pay-state-R">취소</span>
                            <span v-if="transState(s) === '결제완료'" class="pay-state-D">결제완료</span>
                        </td>
                        <td>
                            <button class="link" @click="payHistoryItem = s">
                                {{ s.nt_moid }}
                            </button>
                        </td>
                        <td>{{ s.nt_ticket_type ? convertBillType(s.nt_ticket_type) : '없음' }}</td>
                        <td class="left">
                            <router-link
                                v-if="!!s.nt_ticket_nm && transState(s) !== '취소'"
                                :to="{
                                    path: `/madmin/member/account/${s.center_id}`,
                                    query: {
                                        customerId: s.customer_id,
                                        contractId: s.nt_contract_id,
                                        allowedCount: null,
                                    },
                                }"
                                class="link"
                            >
                                {{ s.nt_ticket_nm }}
                            </router-link>
                            <span v-else>{{ s.nt_ticket_nm || '오프라인 결제' }}</span>
                        </td>
                        <td>{{ s.nt_member_nm || '---' }}</td>
                        <td>
                            {{ s.nt_member_phone | customerPhoneFilter }}
                        </td>
                        <td>
                            <template v-if="!!s.nt_fn_cd">
                                <p>
                                    {{ s.nt_fn_cd ? cardTypes[s.nt_fn_cd] : '' }}
                                    <span v-if="!!s.nt_install_mnt">
                                        ({{ s.nt_install_mnt === '00' ? '일시불' : `${Number(s.nt_install_mnt)}개월` }})
                                    </span>
                                </p>
                                <p>{{ (s.nt_payment_no || '') | cardNumberFilter }}</p>
                            </template>
                            <span v-else>---</span>
                        </td>
                        <td>
                            <span v-if="!!s.nt_sms_req_price || !!s.nt_goods_amt" :class="transColor(s)">
                                {{ (s.nt_sms_req_price || s.nt_goods_amt) | numberFormatFilter }}원
                            </span>
                            <span v-else>---</span>
                        </td>
                        <td>
                            <span v-if="transState(s) === '결제대기'">---</span>
                            <span v-else :class="transColor(s)">{{ s.nt_goods_amt | numberFormatFilter }}원</span>
                        </td>
                        <td>
                            <button
                                v-if="transState(s) === '결제대기'"
                                class="com-btn"
                                @click="handleSendPaymentLink(s)"
                            >
                                재발송
                            </button>
                            <button v-if="transState(s) !== '취소'" class="com-btn red" @click="cancelFitpayItem = s">
                                취소
                            </button>
                        </td>
                    </tr>
                    <tr v-if="fitpayList.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <!-- 추후에 구현함 -->
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                class="mt-10"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <payment-history-dlg
            v-if="!!payHistoryItem"
            :show="!!payHistoryItem"
            :moid="payHistoryItem ? payHistoryItem.nt_moid : ''"
            :close="() => (payHistoryItem = null)"
        ></payment-history-dlg>

        <payment-cancel-dlg
            :show="!!cancelFitpayItem"
            :data="cancelFitpayItem || {}"
            :close="() => (cancelFitpayItem = null)"
            :confirm="handelCancelPayment"
        ></payment-cancel-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { Utils } from '@/assets/js/utils';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import XLSX from 'xlsx';
import { numberFormat, customerPhoneForExcel, dateFormatFilter } from '@/assets/js/excelCommon.js';
import { pagingInfo, TICKET_TYPES, TICKET_INFO, NICEPAY_CARDS } from '@/assets/js/common';
import PaymentHistoryDlg from '@/components/PaymentHistoryDlg.vue';
import PaymentCancelDlg from '@/components/PaymentCancelDlg.vue';

export default {
    name: 'SalesFitPayment',
    mixins: [MixinAllowedMenu],
    components: { PaymentHistoryDlg, PaymentCancelDlg },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.fetchFitpayList(1);
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
            this.fetchFitpayList(1);
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
            this.fetchFitpayList(1);
        },
        payState(newValue) {
            // 결제항목
            this.fetchFitpayList(1);
        },
        procState(newValue) {
            // 결제항목
            this.fetchFitpayList(1);
        },
        searchTicketType(newValue) {
            this.fetchFitpayList(1);
        },
    },
    data() {
        return {
            openFilter: true,
            submenus: [
                { name: 'SalesFitPayment', label: '결제 내역' },
                { name: 'SalesFitSettlement', label: '정산 내역' },
            ],
            ticketOptions: [{ text: '전체', value: '' }, ...TICKET_INFO],
            ticketTypes: TICKET_TYPES,
            cardTypes: NICEPAY_CARDS,
            payStates: [
                { text: '전체', value: '' },
                { text: '결제완료', value: 'D' },
                { text: '결제대기', value: 'P' },
                { text: '취소', value: 'C' },
            ],
            sortColumns: {
                처리일: 'date',
                주문번호: 'moid',
                최종금액: 'price',
            },
            sortColumn: 'date',
            sortType: 'DESC',
            payState: '', // 결제 상태 - A: 접수성공, R: 접수실패, D: 결제완료, P: 진행중,
            procState: '', // 진행 상태
            searchTicketType: '',
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            searchPeriod: '', // 검색 기간 설정
            searchStr: '', // 이름, 연락처 검색 파라미터

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            centerId: '',
            fitpayList: [],
            totalItems: '',
            totalPrices: {},

            cancelFitpayItem: null,
            payHistoryItem: null,
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.pagingInfo.page = 1;
        this.pagingInfo.limit = 10;
        this.fetchFitpayList();
    },
    methods: {
        // 리스트 조회
        async fetchFitpayList(pageNum) {
            try {
                const { data } = await api.get(`/admin/api/center/fitpay/transaction/sales/${this.centerId}`, {
                    params: {
                        searchStr: this.searchStr,
                        startDate: moment(this.startDate).format('YYYYMMDD'), // 검색시작일
                        endDate: moment(this.endDate).format('YYYYMMDD'), // 검색종료일
                        state: this.payState, //this.procState || this.payState,
                        ticketType: this.searchTicketType,
                        sortColumn: this.sortColumn,
                        sortType: this.sortType,
                        ...this.pagingInfo,
                        page: pageNum || this.pagingInfo.page,
                    },
                });

                console.log(data);

                this.setPageParams(data);
                this.fitpayList = data.items;
                this.totalPrices = data.prices || {};
                this.totalItems = data.meta.totalItems;
            } catch (error) {
                console.log('핏페이 매출', error);
            }
        },

        sortClassState(sortName) {
            if (!sortName) return '';
            const sortCol = this.sortColumns[sortName] || '';
            if (sortCol === this.sortColumn) return this.sortType === 'DESC' ? 'desc' : 'asc';
            return 'none';
        },
        async handleSortColumn(sortName) {
            if (!sortName) return;
            const sortCol = this.sortColumns[sortName] || '';

            if (sortCol === this.sortColumn) this.sortType = this.sortType === 'DESC' ? 'ASC' : 'DESC';
            else this.sortType = 'DESC';

            this.sortColumn = sortCol;
            this.fetchFitpayList();
        },

        async handelCancelPayment(amount) {
            const { nt_id } = this.cancelFitpayItem;
            const res = await api.post(`/admin/api/center/fitpay/payment/${this.centerId}/cancel/${nt_id}/${amount}`);
            if (res.data.response.statusCode === 500) {
              if (res.data.response.error.indexOf('취소금액이 미정산 금액보다 큽니다') !== -1) {
                alert('현재 취소 처리를 할 수 없습니다.(정산금 부족)');
              } else {
                alert(res.data.response.message);
              }
            } else {
              this.cancelFitpayItem = null;
              this.fetchFitpayList();
              alert('취소 처리가 완료되었습니다.');
            }
        },

        async handleSendPaymentLink(t) {
            const { nt_id } = t;

            const res = await api.post(`/admin/api/center/fitpay/payment/${this.centerId}/resend/${nt_id}`);
            if (res.data.reqId) {
                alert('핏페이 링크가 재전송되었습니다.');
            }
            console.log(res);
            this.fetchFitpayList();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchFitpayList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchFitpayList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.searchStr = '';
            EventBus.$emit('event:initList', 'init');
        },
        // 페이징 기본값
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },
        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.fetchFitpayList(1);
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            if (this.dateChangeCount > 2) {
                this.fetchFitpayList(1);
            }
            this.dateChangeCount += 1;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            if (this.dateChangeCount > 2) {
                this.fetchFitpayList(1);
            }
            this.dateChangeCount += 1;
        },

        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const { data } = await this.fetchFitpayListExcel(); // 엑셀용 요청값
            console.log(data);

            let sum_total_price = 0,
                sum_bill_price = 0;
            const excelDownloadArray = [];
            data.items.forEach((s) => {
                const temp = {};
                temp['처리일'] = dateFormatFilter(s.nt_reg_dt);
                temp['결제상태'] = this.transState(s);
                temp['주문번호'] = s.nt_moid;
                temp['구분'] = this.convertBillType(s.nt_ticket_type);
                temp['이용권 명'] = s.nt_ticket_nm;
                temp['회원명'] = s.nt_member_nm;
                temp['휴대폰전화번호'] = customerPhoneForExcel(s.nt_member_phone);
                temp['결제수단'] = !!s.nt_fn_cd
                    ? `${this.cardTypes[s.nt_fn_cd]} ${Utils.formatCardNumber(s.nt_payment_no || '')}`
                    : '---';
                temp['금액'] = numberFormat(s.nt_sms_req_price || s.nt_goods_amt || 0);
                temp['최종금액'] = numberFormat(s.nt_goods_amt || 0);

                sum_total_price += s.nt_sms_req_price || s.nt_goods_amt || 0;
                sum_bill_price += s.nt_goods_amt || 0;

                excelDownloadArray.push(temp);
            });

            // 합계 부분 산출
            const temp = {};
            temp['처리일'] = '합계';
            temp['결제상태'] = '';
            temp['주문번호'] = '';
            temp['구분'] = '';
            temp['이용권 명'] = '';
            temp['회원명'] = '';
            temp['휴대폰전화번호'] = '';
            temp['결제수단'] = '';
            temp['금액'] = numberFormat(sum_total_price);
            temp['최종금액'] = numberFormat(sum_bill_price);

            excelDownloadArray.push(temp);
            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '핏페이 매출(결제내역)');
            XLSX.writeFile(wb, '핏페이매출_결제내역.xlsx');
        },
        fetchFitpayListExcel() {
            return api.get(`/admin/api/center/fitpay/transaction/sales/${this.centerId}`, {
                params: {
                    searchStr: this.searchStr,
                    startDate: moment(this.startDate).format('YYYYMMDD'), // 검색시작일
                    endDate: moment(this.endDate).format('YYYYMMDD'), // 검색종료일
                    state: this.procState || this.payState,
                    ticketType: this.searchTicketType,
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                    ...this.pagingInfo,
                    page: 1,
                    limit: 1000,
                },
            });
        },
        // 상품 등록코드 변환
        convertBillType(type) {
            if (!type) return '';

            return this.ticketTypes[type];
        },
        transState(d) {
            if (!d.nt_tid) return '결제대기';
            else if (!!d.nt_cc_dt) return '취소';
            else return '결제완료';
        },
        transColor(d) {
            if (!d.nt_tid) return 'pay-state-P';
            else if (!!d.nt_cc_dt) return 'pay-state-R';
            else return 'pay-state-D';
        },
        async test1() {
            const transactions = await api.get(`/admin/api/center/fitpay/transaction/result`);
            console.log(transactions, '거래대사 조회');
        },
        async test2() {
            const transactions = await api.get(`/admin/api/center/fitpay/settlement/result`);
            console.log(transactions, '정산대사 조회');
        },
        async test3() {
            const linkResults = await api.get(`/admin/api/center/fitpay/links/result`);
            console.log(linkResults, '링크결제 결과 조회');
        },
    },
};
</script>
<style lang="scss"></style>
